import React, { useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { getLocaleObjContent } from '@/utils/language.util';
import StorageService from '@/services/storage.service';

export default function GolbalMenu() {
    const [isOpen, setIsOpen] = useState('false');
    const [show, setShow] = useState(false);
    const [num, setNum] = useState();

    const history = useHistory();

    const onShowMenu = (isOpen) => {
        setIsOpen(isOpen);
    };
    const checkShow = (num) => {
        setShow(!show);
        setNum(num);
    };
    const handleLogout = () => {
        new StorageService().user_id.remove();
        new StorageService().user_no.remove();
        history.replace('/');
    };

    return (
        <>
            <div className="main_top">
                <div className={`m_nav${isOpen ? '' : ' active'}`}>
                    <div className="m_nav_top">
                        <div className="close" onClick={() => onShowMenu(!isOpen)}>
                            <img src={require('@/resources/assets/images/back.png')} alt="close" />
                        </div>
                    </div>
                    <ul className="m_nav_list">
                        <li onClick={() => onShowMenu(!isOpen)} id="nav_logo">
                            <Link to="/home">
                                <img
                                    className="logo_nav"
                                    src={require('@/resources/assets/images/logo.png')}
                                    alt="logo"
                                />
                            </Link>
                        </li>
                        {getLocaleObjContent('menu').map((it, index) => (
                            <li
                                key={index}
                                onClick={() => {
                                    index !== 3 && (index !== 4) & (index !== 7)
                                        ? onShowMenu(!isOpen)
                                        : index === 3 || index === 4
                                        ? checkShow(index)
                                        : handleLogout();
                                }}
                            >
                                <span className={show && num === index ? 'show' : 'hide'}>
                                    <Link to={it.to} replace>
                                        {it.link}
                                    </Link>
                                </span>
                                {show && num === index ? (
                                    <ul className="menu_child">
                                        {getLocaleObjContent(`menu.child${index}`).map((item, index) => (
                                            <li key={index} onClick={() => onShowMenu(!isOpen)}>
                                                <Link to={item.to} replace>
                                                    <span>{item.link}</span>
                                                </Link>
                                            </li>
                                        ))}
                                    </ul>
                                ) : null}
                            </li>
                        ))}
                    </ul>
                </div>

                <img
                    src={require('@/resources/assets/images/menu.png')}
                    className="menu nav_btn"
                    alt="btn-menu"
                    onClick={() => onShowMenu(!isOpen)}
                />
                <Link to="/home">
                    <img src={require('@/resources/assets/images/logo2.png')} className="logo" alt="menu" />
                </Link>
            </div>
        </>
    );
}
